// Import api models.
import {
	EligibilityMessagePriorityWithId
} from '@app/models/api';

interface EligibilityMessagePrioritiesState {
	areEligibilityMessagePrioritiesLoaded: boolean;
	eligibilityMessagePriorities: EligibilityMessagePriorityWithId[];
	selectedEligibilityMessagePriorityId?: string | undefined;
};

const getInitialState = (): EligibilityMessagePrioritiesState => {
	return {
		areEligibilityMessagePrioritiesLoaded: false,
		eligibilityMessagePriorities: [],
		selectedEligibilityMessagePriorityId: undefined
	};
};

export { getInitialState, EligibilityMessagePrioritiesState };